var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramChipGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17.99 17.99",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "igChipFill",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 10,
    gradientTransform: "matrix(2.1588 0 0 2.1588 3.598 19.789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(253, 209, 91)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(250, 164, 73)",
    offset: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(247, 119, 55)",
    offset: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(243, 81, 89)",
    offset: 0.415
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(238, 42, 123)",
    offset: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(188, 50, 154)",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(138, 58, 185)",
    offset: 0.85
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#igChipFill)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramChipGradient);
export default __webpack_public_path__ + "static/media/instagram-chip-gradient.a06b859088104b61f97aa7963edcfb7d.svg";
export { ForwardRef as ReactComponent };